import { Box, Theme, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { HTMLMotionProps, motion } from "framer-motion";
import { FC } from "react";

interface IProgressBarProps {
    value: number;
    barStyle?: SxProps<Theme>;
    containerStyle?: SxProps<Theme>;
    motionProps?: HTMLMotionProps<'div'>,
    duration?: number;
    delay?: number;
    children?: React.ReactNode;
}

const ProgressBar: FC<IProgressBarProps> = ({
    value,
    barStyle,
    containerStyle,
    motionProps,
    duration = 1,
    delay = 0,
    children
}) => {
    const theme = useTheme();

    return(
        <Box sx={{ width: '100%', height: theme.spacing(1), ...containerStyle }}>
            <motion.div
                initial={{
                    width: `${0}%`,
                }}
                animate={{ width: `${value || 0}%` }}
                transition={{
                    ease: 'linear',
                    duration: duration,
                    delay: delay,
                }}
                style={{
                    height: '100%',
                }}
                {...motionProps}
            >
                <Box sx={{ 
                    height: '100%',
                    background: 'linear-gradient(90deg, #FFC65C 0%, #FF825C 100%)',
                    borderRadius: theme.spacing(0.5),
                    ...barStyle 
                }}>
                    {children}
                </Box>
            </motion.div>
        </Box>
    )
}

export default ProgressBar;